// The JavaScript selects the correct modal based on the data-modal attribute:
// For each link with the class modalLink, the JavaScript retrieves the data-modal attribute to identify the associated modal by ID, then opens that specific modal.

// Get all modal links
  var modalLinks = document.querySelectorAll(".mr-custom-modalLink");

  // Loop through each link and add a click event listener
  modalLinks.forEach(function(link) {
    link.onclick = function(event) {
      // Prevent default link behavior
      event.preventDefault();

      // Get the modal ID from data attribute
      var modalId = this.getAttribute("data-modal");
      var modal = document.getElementById(modalId);

      // Display the correct modal
      modal.style.display = "block";
    };
  });

  // Get all close buttons
  var closeButtons = document.querySelectorAll(".mr-custom-modal-close");

  // Add click event to each close button
  closeButtons.forEach(function(button) {
    button.onclick = function() {
      // Get the modal ID from data attribute
      var modalId = this.getAttribute("data-modal");
      var modal = document.getElementById(modalId);

      // Hide the modal
      modal.style.display = "none";
    };
  });

  // Close the modal when clicking outside of it
  window.onclick = function(event) {
    if (event.target.classList.contains("mr-custom-modal")) {
      event.target.style.display = "none";
    }
  }